import { utils } from "pixi.js";
import { decorate, injectable } from "inversify";

decorate(injectable(), utils.EventEmitter);

@injectable()
export class EventBus extends utils.EventEmitter {}
